<app-header-user></app-header-user>
<!-- Page title -->
<!-- <div class="page-title-area bg-programari">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Acasă</a></li>
        <li>Programări</li>
      </ul>
      <h2>Programările mele</h2>
    </div>
  </div>
</div> -->

<div class="container pt-4 pb-5">
    <div class="row">
        <!-- Info box sus -->
        <div class="col-12 mb-4">
            <h2>Documente pentru medic</h2>
            <p class="mb-0 small text-muted">
                Dacă aveți documente medicale (rezultate analize, scrisori
                medicale, bilete de ieșire din spital etc.) care trebuie să
                ajungă la medicul de familie / specialist, încărcați-le în
                modulul
                <strong>Documente medicale</strong>.
            </p>
            <a
                routerLink="/efectueaza-programare"
                class="btn btn-success btn-rounded my-2"
            >
                <i class="bx bx-calendar-plus me-1"></i> Efectuează o programare
            </a>
        </div>
    </div>

    <!-- Tabs curente / istoric -->
    <ngx-tabset class="tableCard-tabs">
        <!-- Tab: Programări curente -->
        <ngx-tab tabTitle="Programări curente">
            <div class="card dashboard-card programari-card">
                <div class="text-center mb-2">
                    Perioadă:
                    {{ startDateView  | date: "dd.MM.yyyy" }} -
                    {{ endDateView  | date: "dd.MM.yyyy" }}
                </div>
                <div class="card-body p-0">
                    <!-- Loading -->
                    <div *ngIf="loading" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-success"
                        ></div>
                    </div>

                    <!-- Tabel programări curente -->
                    <div
                        *ngIf="!loading"
                        class="table-responsive programari-table-wrapper"
                    >
                        <table class="table table-sm mb-0 programari-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Data / Ora</th>
                                    <th>Grad</th>
                                    <th>Specializare</th>
                                    <th>Medic</th>
                                    <th>Tip</th>
                                    <th>Portal</th>
                                    <th>Status</th>
                                    <th class="text-end">Acțiune</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngIf="
                                        getActiveAppointments(appointments)
                                            .length === 0
                                    "
                                >
                                    <td
                                        colspan="9"
                                        class="text-center text-muted py-3"
                                    >
                                        {{
                                            message ||
                                                "Nu ai programări active."
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    *ngFor="
                                        let appointment of getActiveAppointments(
                                            appointments
                                        )
                                    "
                                >
                                    <td>{{ appointment.nrCrt }}</td>
                                    <td>
                                        {{
                                            appointment.startDate
                                                | date: "dd.MM.yyyy"
                                        }},
                                        {{ appointment.startHour }}
                                    </td>
                                    <td>
                                        {{ appointment.professionalDegree }}
                                    </td>
                                    <td>{{ appointment.specialtyName }}</td>
                                    <td>{{ appointment.doctorName }}</td>
                                    <td>
                                        <span class="badge bg-outline-warning">
                                            {{
                                                appointment.message ||
                                                    "Programare fără plată"
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="badge bg-outline-info">
                                            {{
                                                appointment.portalAssigned
                                                    ? "Da"
                                                    : "Nu"
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="
                                                getStatus(appointment) ===
                                                'Activa'
                                                    ? 'bg-success'
                                                    : 'bg-secondary'
                                            "
                                        >
                                            {{
                                                getStatus(appointment)
                                                    | uppercase
                                            }}
                                        </span>
                                    </td>
                                    <td class="text-end">
                                        <button
                                            type="button"
                                            class="btn btn-xs btn-outline-danger btn-rounded"
                                            (click)="cancel(appointment)"
                                        >
                                            Anulează
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ngx-tab>

        <!-- Tab: Istoric programări -->
        <ngx-tab tabTitle="Istoric programări">
            <div class="card dashboard-card">
                <div class="card-body p-0">
                    <div class="text-center mb-2">
                        Perioadă:    {{ startDateView  | date: "dd.MM.yyyy" }} -
                    {{ endDateView  | date: "dd.MM.yyyy" }}
                    </div>
                    <!-- Loading -->
                    <div *ngIf="loading" class="text-center py-4">
                        <div
                            class="spinner-border spinner-sm text-secondary"
                        ></div>
                    </div>

                    <!-- Tabel istoric -->
                    <div
                        *ngIf="!loading"
                        class="table-responsive programari-table-wrapper"
                    >
                        <table class="table table-sm mb-0 programari-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Data / Ora</th>
                                    <th>Grad</th>
                                    <th>Specializare</th>
                                    <th>Medic</th>
                                    <th>Tip</th>
                                    <th>Portal</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngIf="
                                        getHistoryAppointments(appointments)
                                            .length === 0
                                    "
                                >
                                    <td
                                        colspan="8"
                                        class="text-center text-muted py-3"
                                    >
                                        {{
                                            message ||
                                                "Nu ai programări în istoric."
                                        }}
                                    </td>
                                </tr>
                                <tr
                                    *ngFor="
                                        let appointment of getHistoryAppointments(
                                            appointments
                                        );
                                        let i = index
                                    "
                                >
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        {{
                                            appointment.startDate
                                                | date: "dd.MM.yyyy"
                                        }},
                                        {{ appointment.startHour }}
                                    </td>
                                    <td>
                                        {{ appointment.professionalDegree }}
                                    </td>
                                    <td>{{ appointment.specialtyName }}</td>
                                    <td>{{ appointment.doctorName }}</td>
                                    <td>
                                        <span class="badge bg-outline-warning">
                                            {{
                                                appointment.message ||
                                                    "Programare fără plată"
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="badge bg-outline-info">
                                            {{
                                                appointment.portalAssigned
                                                    ? "Da"
                                                    : "Nu"
                                            }}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            class="badge"
                                            [ngClass]="
                                                getStatus(appointment) ===
                                                'Onorata'
                                                    ? 'bg-success'
                                                    : 'bg-secondary'
                                            "
                                        >
                                            {{
                                                getStatus(appointment)
                                                    | uppercase
                                            }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ngx-tab>
    </ngx-tabset>
</div>
